/**
 * codCashReceiptBus: open the one COD cash receipt dialog from anywhere.
 *
 * The dialog (components/CodCashReceiptDialog.js) is mounted ONCE in App.js.
 * Nine order-detail screens share the "Mark as Paid" switch through the
 * markOrderAsPaid action, and the Riders table has its own button, so neither
 * holds dialog state. They call openCodCashReceipt(request) instead:
 *
 *   openCodCashReceipt({ mode: "order", orderId, amount })
 *   openCodCashReceipt({ mode: "rider", riderId, riderName, heldBalance, onDone })
 */
const listeners = new Set();

export const openCodCashReceipt = (request) => {
  listeners.forEach((listener) => listener(request));
};

export const subscribeCodCashReceipt = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
